import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { BillEmail } from './bill-email';
import { BillAddress } from './bill-address';
import { CustomerMemo } from './customer-memo';
import { MetaData } from './meta-data';
import { CustomerRef } from './customer-ref';
import { SaleItem } from './sale-item';
import { LinkedTxn } from './linked-txn';
import { CustomField } from './custom-field';
import { TxnTaxDetail } from './txn-tax-details';

@JsonObject('model.project.ProjectSale')
export class ProjectSale extends AbstractModel {

	@JsonProperty(String, 'id')
	id: string;

	@JsonProperty(String, 'docNumber')
	docNumber?: string;

	@JsonProperty(String, 'domain')
	domain?: string;

	@JsonProperty(String, 'txnStatus')
	txnStatus?: string;

	@JsonProperty(TxnTaxDetail, 'txnTaxDetail')
	txnTaxDetail?: TxnTaxDetail;

	@JsonProperty(Number, 'balance')
	balance?: number;

	balanceDue?: number;

	@JsonProperty(Number, 'totalAmt')
	totalAmt?: number;

	@JsonProperty(BillEmail, 'billEmail')
	billEmail?: BillEmail;

	@JsonProperty(BillAddress, 'billAddr')
	billAddr?: BillAddress;

	@JsonProperty(BillAddress, 'shipAddr')
	shipAddr?: BillAddress;

	@JsonProperty(MetaData, 'metaData')
	metaData?: MetaData;

	@JsonProperty(CustomerMemo, 'customerMemo')
	customerMemo?: CustomerMemo;

	@JsonProperty(CustomerRef, 'customerRef')
	customerRef?: CustomerRef;

	@JsonProperty([CustomField], 'customField')
	customField?: CustomField[];

	@JsonProperty(DateConverter, 'dueDate')
	dueDate?: Date;

	@JsonProperty([SaleItem], 'line')
	line?: SaleItem[];

	@JsonProperty([LinkedTxn], 'linkedTxn')
	linkedTxn?: LinkedTxn[];

	type?: string;

	status?: string;

	statusNum?: number;

	recievedPayments?: number;

	paymentsList?: ProjectSale[];
}
